module.exports = __webpack_public_path__ + "img/zixuncode-bl.69d2dad1.png";